import { InspectionPointStates, InspectionPointConfiguration } from "../../../DTOs";
import { basicValidation } from "../basicValidation";
import { fieldValidation } from "../fieldValidation";

export const safetyInspectionFieldValidation = {
    facilityInspection: {
        id: (value:string) => basicValidation.resourceId.isValid(value),
        activityId: (value:string) =>  basicValidation.resourceId.isValid(value),
        facilityId: (value:string) =>  basicValidation.resourceId.isValid(value),
        inspectionPointId: (value:string) =>  basicValidation.resourceId.isValid(value, 128),
        locationId: (value:string) =>  basicValidation.resourceId.isValid(value),
        status: (value:string) => typeof(value)==='string' && InspectionPointStates.some(s => s === value)===true,
        comment: (value:string) =>  basicValidation.resourceText.isValid(value, true, 1000),
    },
    
    inspectionPoint: {
        id: (value:string) =>  basicValidation.resourceId.isValid(value),
    },

    inspectionPointModification: {
        id: (value:string) =>  basicValidation.resourceId.isValid(value, 128),
        config:(value:InspectionPointConfiguration) => {
            if(value === null || value === undefined || typeof(value) !== 'object') return false;
            if(Array.isArray(value.facilityTypeIds) === false) return false;
            if(value.facilityTypeIds.some(t => !fieldValidation.facilityType.id(t))) return false;
            if(!basicValidation.stringValuesAreUnique(value.facilityTypeIds)) return false;
            return true;
        },
        title: (value:string) =>  basicValidation.resourceText.isValid(value, false, 100),
        instructions: (value:string) =>  basicValidation.resourceText.isValid(value, false, 1000),
        disabled: (value:boolean) => basicValidation.validateBoolean(value),
    }
};